const emailList = {
    getEmailLists: '/emaillist/getEmailLists',
    getEmailList: '/emaillist/getEmailList',
    summaryEmailListContacts: '/emaillist/summaryEmailListContacts',
    summaryOfContacts: '/api/emaillist/summaryOfContacts',
    getSummaryCount: '/api/emaillist/getSummaryCount',
    getSavedSummary: '/api/emaillist/getSavedSummary',
    getPostMailingContatsCount: '/api/emaillist/getPostMailingContatsCount',
    saveEmailList: '/api/emaillist/saveSummaryOfContacts',
    deleteEmailList: '/api/emaillist/deleteEmailList',
    // getEmailListContacts: '/emaillist/getEmailListContacts',
    getEmailListDetail: '/api/emaillist/getEmailListDetail',
    renameEmailList: '/api/emaillist/renameEmailList',
    deleteContacts: '/api/emaillist/deleteContacts',
    getUsers: '/emailList/getUsers',
    savePublishEmailList: '/emailList/emailList',
    getEmaiListOfContactById: '/emailList/getEmailListofContactById',
    getContacts: '/api/emaillist/getContactsForAdd',
    updateEmailListForAddDelete: '/emailList/updateEmailListForAddDelete',
    getCount: '/esUtility/getCount',
    uploadEmailListCSV: '/api/emaillist/emailListUploader',
    createNewEmailListCSV: '/api/emaillist/createNewList',
    downloadEmailListCSV: '/api/emaillist/downloadcsv',
    cloneEmailList: '/api/emaillist/cloneEmailList',
    addContactsToEmailList: '/api/emaillist/addContacts',
    downloadcsv: '/api/emaillist/getContactsCSV',
}
export default emailList